/**
 * Trial Balance (BE-30) — real API.
 *
 * Every GL account with its opening balance, the range's debits and credits and its closing balance (opening / closing
 * on one side: `{ debit, credit }`, the other null), plus totals and `balanced` / `difference`. `from` and `to` must be
 * in one calendar year; `to` defaults to today and `from` to 1 January of its year.
 */

import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';

export const trialBalanceService = {
  // from / to as YYYY-MM-DD
  get: async ({ from, to } = {}) =>
    unwrapData(await ApiService.get('/api/reports/trial-balance', {
      params: Object.fromEntries(Object.entries({ from, to }).filter(([, v]) => v)),
    })),
};

export default trialBalanceService;
